import { render, staticRenderFns } from "./NuisanceDisk.vue?vue&type=template&id=1b7ba6af&scoped=true"
import script from "./NuisanceDisk.vue?vue&type=script&lang=js"
export * from "./NuisanceDisk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7ba6af",
  null
  
)

export default component.exports